<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import {
		session
	} from '@/js/util'
	export default {
		name: 'App',
		created() {
			console.log(session('token'))
			this.init()
		},
		data() {
			return {
				token: ''
			}
		},
		methods: {
			init() {
				this.token = session('token')
				if (!this.token) {
					return this.$router.push({
						name: 'login'
					});
				}
			}
		}
	}
</script>

<style lang="scss">
	@import "./css/config.scss";
	@import "./css/common.scss";

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: $black;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		font-size: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue